import _toConsumableArray from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _createForOfIteratorHelper from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _defineProperty from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.map.get-or-insert.js";
import "core-js/modules/es.map.get-or-insert-computed.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getGoodList, getUnionActivity, getBookList } from '@/views/custom-layout/api';
export default {
  name: 'configMenu',
  inject: {
    packageListDecorationOnlyProgramme: {
      default: false
    }
  },
  props: _defineProperty(_defineProperty(_defineProperty(_defineProperty({
    propName: {
      type: String,
      default: 'value'
    },
    // 表单校验前缀
    index: {
      type: Number,
      default: -1
    },
    type: String,
    info: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    menuList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    childrenMenuList: Array,
    customerModuleList: Array,
    eBookCategoryList: Array,
    aBookCategoryList: Array
  }, "customerModuleList", Array), "customerPackageList", Array), "systemMenus", Object), "value", {
    type: Object,
    default: function _default() {
      return {};
    }
  }),
  data: function data() {
    return {
      goodsList: [],
      bookList: [],
      activityList: [],
      currentMenu: {},
      mapMenus: null,
      current_module_type: ''
    };
  },
  methods: {
    remoteBook: function remoteBook(value) {
      var _this = this;
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var book_type = value.book_type,
        module_plate_id = value.link_value,
        book_category = value.book_category;
      getBookList(_objectSpread({
        customer_id: this.info.customer_id,
        book_type: book_type,
        module_plate_id: module_plate_id,
        category_name: book_category === null || book_category === void 0 ? void 0 : book_category.category_name,
        pagesize: 20,
        page: 1
      }, params)).then(function (res) {
        _this.bookList = res.data;
      });
    },
    changeBookCategory: function changeBookCategory(book_category) {
      var book_id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      this.value.book_id = book_id;
      if (book_category !== null && book_category !== void 0 && book_category.category_name) {
        this.remoteBook(this.value, {
          book_id: book_id
        });
      }
    },
    clearBook: function clearBook(clearArr) {
      var _this2 = this;
      clearArr.forEach(function (p) {
        return _this2.value[p] = '';
      });
    },
    onCopy: function onCopy() {
      var oInput = document.createElement('input');
      oInput.value = '/';
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand('Copy');
      oInput.style.display = 'none';
      this.$message.success('复制成功');
      document.body.removeChild(oInput);
    },
    isValueRequired: function isValueRequired(value) {
      if (['banner', 'banner_new'].includes(this.type) && ['1', '2', '3', '4', '7', '8'].includes(value.link_type + '')) {
        // banner & 图片楼层组件 以上情况允许非必填
        return false;
      }
      return true;
    },
    onChange: function onChange(value) {
      value.link_value = '';
      value.book_type = '1';
      value.book_category = '';
      value.book_id = '';
      this.$set(value, 'goods_id', '');
      this.$set(value, 'module_plate_id', '');
      this.$set(value, 'wx_appid', '');
      this.$set(value, 'wx_path', '');
      this.$set(value, 'is_today_on', '');
      this.currentMenu = {};
    },
    // 获取系统菜单列表
    changeLinkValue: function changeLinkValue(value) {
      var _this3 = this;
      var prop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var menusid = prop.menusid,
        _prop$isClear = prop.isClear,
        isClear = _prop$isClear === void 0 ? false : _prop$isClear;
      if (value.link_type + '' === '1') {
        this.currentMenu = this.mapMenus.get(menusid) || {};
        var _this$currentMenu = this.currentMenu,
          type = _this$currentMenu.type,
          is_today_on = _this$currentMenu.is_today_on;
        if (isClear || type !== 'cake' || type === 'cake' && is_today_on + '' !== '1') {
          this.$set(value, 'is_today_on', '');
        }
      } else if (value.link_type + '' === '4') {
        var currentModule = this.customerModuleList.find(function (i) {
          return i.id === menusid;
        });
        this.current_module_type = currentModule === null || currentModule === void 0 ? void 0 : currentModule.module_type;
        if (this.current_module_type === 'staff_library') {
          isClear && this.clearBook(['book_category', 'book_id']);
          this.changeBookCategory(value.book_category, value.book_id);
        }
      } else if (value.link_type + '' === '5') {
        isClear && this.$set(value, 'goods_id', '');
        if (menusid) {
          getGoodList(_objectSpread({
            menusid: menusid
          }, params), this.info.module).then(function (res) {
            _this3.goodsList = res.data;
          });
        }
      }
    },
    changeValueSaas: function changeValueSaas(value) {
      var _this4 = this;
      var prop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var module_plate_id = prop.module_plate_id,
        _prop$isClear2 = prop.isClear,
        isClear = _prop$isClear2 === void 0 ? false : _prop$isClear2;
      var _this$info = this.info,
        customer_id = _this$info.customer_id,
        module = _this$info.module;
      if (value.link_type + '' !== '6') {
        return;
      }
      isClear && this.$set(value, 'link_value', '');
      if (module_plate_id) {
        getUnionActivity({
          module_plate_id: module_plate_id,
          customer_id: customer_id
        }, module).then(function (res) {
          _this4.activityList = res.data;
        });
      }
    },
    buildMapData: function buildMapData(list) {
      var mapMenus = new Map();
      var _dfs = function dfs(nodes) {
        if (!nodes) return;
        var _iterator = _createForOfIteratorHelper(nodes),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var node = _step.value;
            mapMenus.set(node.id, node);
            _dfs(node.childrens);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      };
      _dfs(list);
      this.mapMenus = mapMenus;
    }
  },
  created: function created() {
    if (this.packageListDecorationOnlyProgramme && !['1', '8'].includes(this.value.link_type + '')) {
      this.$set(this.value, 'link_type', '8');
      this.onChange(this.value);
    }
    this.buildMapData(this.menuList);
    this.$set(this.value, 'is_today_on', this.value.is_today_on || '');
    this.$set(this.value, 'book_type', this.value.book_type || '1'); // '1' 图书类型 1-电子书,2-有声书
    this.$set(this.value, 'book_category', this.value.book_category || ''); // 图书分类
    this.$set(this.value, 'book_id', this.value.book_id || ''); // 图书ID
    var _this$value = this.value,
      menusid = _this$value.link_value,
      goods_id = _this$value.goods_id,
      module_plate_id = _this$value.module_plate_id;
    this.changeLinkValue(this.value, {
      menusid: menusid
    }, {
      goods_id: goods_id
    });
    this.changeValueSaas(this.value, {
      module_plate_id: module_plate_id
    });
  },
  computed: {
    linkTypeList: function linkTypeList() {
      var list = [{
        label: '选菜单',
        value: '1'
      }, {
        label: '输入链接',
        value: '2'
      }, {
        label: '子页面',
        value: '3'
      }].concat(_toConsumableArray(['plat_custom', 'service_custom', 'plat_service_custom', 'custom'].includes(this.info.module) ? [{
        label: '智慧工会',
        value: '4'
      }, {
        label: 'SaaS活动',
        value: '6'
      }] : []), [{
        label: '选礼包方案',
        value: '8'
      }, {
        label: '选商品',
        value: '5'
      }, {
        label: '系统功能',
        value: '7'
      }, {
        label: '跳转小程序',
        value: '9'
      }]);
      return this.packageListDecorationOnlyProgramme ? list.filter(function (item) {
        return ['1', '8'].includes(item.value);
      }) : list;
    },
    menuListFilter: function menuListFilter() {
      return this.menuList.filter(function (i) {
        return ['entity', 'new_entity', 'code'].includes(i.type);
      });
    },
    moduleActivityList: function moduleActivityList() {
      return this.customerModuleList.filter(function (i) {
        return i.is_have_child;
      });
    }
  }
};